export const PERMISSIONS = {
    ADMIN: 'administrator'
}
